import { IPanelListData } from './panel-list.models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'panel-list',
  template: require('./panel-list.component.html'),
  styles: [require('./panel-list.component.scss')],
})
export class PanelListComponent {
  @Input() listData: IPanelListData | any;
}
